import api from '@/backend/api'
import Vue from 'vue'

const stateAbstract = {
  createLoader: false,
  retrieveLoader: false
}

const actionsAbstract = {
  LIST: ({ commit }, { resource, params, loader = true, headers, responseType }) => {
    return new Promise((resolve, reject) => {
      if (loader) {
        commit('TOGGLE_RETRIEVE_LOADER')
      }
      api.list(resource, params, headers, responseType)
      .then(response => {
        commit('SET_LIST', { response: response, resource: resource })
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
      .finally(() => {
        if (loader) {
          commit('TOGGLE_RETRIEVE_LOADER')
        }
      })
    })
  },
  RETRIEVE: ({ commit }, { resource, id, detail, query, setDetail = true, loader = true, headers, responseType }) => {
    return new Promise((resolve, reject) => {
      if (loader) {
        commit('TOGGLE_RETRIEVE_LOADER')
      }
      api.retrieve(resource, id, detail, query, headers, responseType)
      .then(response => {
        if (setDetail) {
          commit('SET_DETAIL', {
            response: response,
            resource: resource,
            loader: loader
          })
        }
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
      .finally(() => {
        if (loader) {
          commit('TOGGLE_RETRIEVE_LOADER')
        }
      })
    })
  },
  CREATE: ({ commit }, { resource, payload, detail, id, headers, setLoader = true, setCommit = true }) => {
    return new Promise((resolve, reject) => {
      if (setLoader) {
        commit('TOGGLE_CREATE_LOADER')
      }
      api.create(resource, payload, detail, id, headers)
      .then(response => {
        if (setCommit) {
          commit('SET_DETAIL', { response: response, resource: resource })
        }
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
      .finally(() => {
        if (setLoader) {
          commit('TOGGLE_CREATE_LOADER')
        }
      })
    })
  },
  UPDATE: ({ commit }, { resource, id, payload, headers, setLoader = true, setCommit = true }) => {
    return new Promise((resolve, reject) => {
      if (setLoader) {
        commit('TOGGLE_CREATE_LOADER')
      }
      api.update(resource, id, payload, headers)
      .then(response => {
        if (setCommit) {
          commit('SET_DETAIL', { response: response, resource: resource })
        }
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
      .finally(() => {
        if (setLoader) {
          commit('TOGGLE_CREATE_LOADER')
        }
      })
    })
  },
  DESTROY: ({ commit }, { resource, id, query, headers, loader = true, commitInstance = true }) => {
    return new Promise((resolve, reject) => {
      if (loader) {
        commit('TOGGLE_DESTROY_LOADER')
      }
      api.destroy(resource, id, headers, query)
      .then(() => {
        if (commitInstance) {
          commit('SET_DELETE', { resource: resource, id: id })
        }
        resolve()
      })
      .catch(error => {
        reject(error)
      })
      .finally(() => {
        if (loader) {
          commit('TOGGLE_DESTROY_LOADER')
        }
      })
    })
  }
}

const mutationsAbstract = {
  SET_LIST: (state, { resource, response }) => {
    state[`${resource.split('/').pop()}List`] = response.data.results
    state[`${resource.split('/').pop()}Count`] = response.data.count
  },
  SET_DETAIL: (state, { response, resource, loader }) => {
    const r = resource.split('/').pop()
    const listName = r + 'List'
    const detailName = r + 'Detail'

    if (state[detailName]) {
      state[detailName] = response.data
    }

    if (state[listName]) {
      const method = response.config.method

      if (method === 'post') {
        state[listName].push(response.data)
      }

      if (['get', 'patch'].includes(method)) {
        const index = state[listName].findIndex((item) => item.id === response.data.id) || 0
        Vue.set(state[listName], index, response.data)
      }
    }
  },
  SET_DELETE: (state, { resource, id }) => {
    const r = resource.split('/').pop()
    const index = state[`${r}List`].findIndex(d => d.id === id)
    state[`${r}List`].splice(index, 1)
  },
  TOGGLE_CREATE_LOADER: (state) => {
    state.createLoader = !state.createLoader
  },
  TOGGLE_RETRIEVE_LOADER: (state) => {
    state.retrieveLoader = !state.retrieveLoader
  },
  TOGGLE_DESTROY_LOADER: (state) => {
    state.destroyLoader = !state.destroyLoader
  }
}

export { stateAbstract, actionsAbstract, mutationsAbstract }
